import api from "@/services/Api";

export default {
  async listPeoples({}, params) {
    try {
      const { data } = await api.get("/peoples", { params });
      return data;
    } catch (e) {
      return false;
    }
  },

  async getPeople({}, id) {
    try {
      const { data } = await api.get("/peoples/" + id);
      return data;
    } catch (e) {
      return false;
    }
  },

  async insertPeople({}, form) {
    try {
      const { data } = await api.post("/peoples", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    } catch (e) {
      return false;
    }
  },

  async updatePeople({}, form) {
    try {
      const { data } = await api.post("/peoples/" + form.get("id"), form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    } catch (e) {
      return false;
    }
  },

  async destroyPeople({}, id) {
    try {
      const { data } = await api.delete("/peoples/" + id);
      return data;
    } catch (e) {
      return false;
    }
  },
};
